<template>
    <div>
        <header-component></header-component>
        <div class="container-fluid g-my-100">
            <div class="row">
                <div class="col-lg-8 offset-lg-2">
                    <div class="row center">
                          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <p class="portal-error-text">
                                  An unexpected error has occurred. Please try again in a few minutes or <a href="#" class="portal-error-text" @click="ToggleHelpForm()">Contact Us</a>.
                                </p>
                            </div>
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <button @click="Route('Home')" class="btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-px-30 g-mx-10 g-my-10">Home</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <footer-component></footer-component>
    </div>
</template>
<script>
    import HeaderComponent from "@/components/shared/HeaderComponent";
    import FooterComponent from "@/components/shared/FooterComponent";
    import HelpForm from "@/components/shared/HelpForm";
    export default {
        components: {HeaderComponent, HelpForm, FooterComponent},
        data(){
            return{
                Account:{},
                showHelpForm:false
            }
        },
        methods: {
            Route(value){
                this.$router.push({name: value});
            },
            ToggleHelpForm(){
                this.showHelpForm = !this.showHelpForm;
                if(this.showHelpForm){
                    document.body.classList.add("body-overflow");
                }else{
                    document.body.classList.remove("body-overflow");
                }
            },
            GetAccountValues(){
                var _this = this;
                axios.get('/Account/Self', {headers: {'Authorization': "Bearer " + localStorage.getItem("token")}})
                .then(function (response) {
                    _this.Account = response.data.raw;
                })
                .catch(function (error) {
                    console.log(error);
                });
            }
        },
        created(){
            this.GetAccountValues();
        }
    }
</script>



// WEBPACK FOOTER //
// ErrorPage.vue?5fd46f72